import { Box, Button, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useIsMobile } from 'app/utils/hooks';
import { routes } from 'app/routing/routesConfig';

const MIN_BUTTON_WIDTH = '88px';

export const PrivacySettings = () => {
  const isMobileView = useIsMobile(false);
  const styles = useMultiStyleConfig('SettingsPageList', {
    isMobile: isMobileView,
    minButtonWidth: MIN_BUTTON_WIDTH,
  });

  const primaryText = 'Privacy';
  const secondaryText =
    'Manage how your profile information may be visible to other Salt Sessions users, and to others outside the platform.';

  return (
    <Box sx={styles.container}>
      <Box sx={styles.textWrapper}>
        <Text sx={styles.primaryText} pt={2} title={primaryText}>
          {primaryText}
        </Text>
        <Text
          sx={styles.secondaryText}
          data-testid="secondary-privacy-text"
          title={secondaryText}
        >
          {secondaryText}
        </Text>
      </Box>
      <Button
        as={Link}
        to={routes.privacySettings.path}
        size="sm"
        variant="secondary"
        p={0}
        minWidth={MIN_BUTTON_WIDTH}
      >
        Manage
      </Button>
    </Box>
  );
};
